import * as React from "react";

export function StepTickIcon(props: Readonly<React.SVGProps<SVGSVGElement>>) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path d="M11.7266 21.1662L6.16665 15.6062L4.27332 17.4862L11.7266 24.9396L27.7266 8.93957L25.8466 7.05957L11.7266 21.1662Z" fill="black"/>
    </svg>
  );
}
